"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GBP = void 0;
const Errors_1 = require("../../../../Errors");
const index_1 = __importDefault(require("../../Money/index"));
class GBP extends index_1.default {
    constructor(value) {
        super(value);
        this.currencyCode = 'GBP';
        this.currencySymbol = '£';
    }
    toPoundsAndPence() {
        return parseFloat((this.value / 100).toFixed(2));
    }
    get display() {
        const [pounds, pence = ''] = String(this.toPoundsAndPence()).split('.');
        const toFixedPence = pence.padEnd(2, '0');
        return `${this.currencySymbol}${parseInt(pounds).toLocaleString('en-GB')}.${toFixedPence}`;
    }
    static fromPoundsAndPence(poundsAndPence) {
        return new GBP(Math.round(poundsAndPence * 100));
    }
    static fromPence(pennies) {
        return new GBP(pennies);
    }
    add(otherMoney) {
        this.matchesCurrency(otherMoney);
        return new GBP(this.value + otherMoney.value);
    }
    subtract(otherMoney) {
        this.matchesCurrency(otherMoney);
        return new GBP(this.value - otherMoney.value);
    }
    matchesCurrency(otherMoney) {
        if (!(otherMoney instanceof GBP)) {
            throw new Errors_1.InvalidCurrency('Expected GBP', 400);
        }
    }
    equals(otherMoney) {
        return this.value === otherMoney.value;
    }
}
exports.GBP = GBP;
exports.default = GBP;
